import { Gondor } from "../Gondor";

const ACTIONS = {
  STATE: "/state/",
  STATE_ITEM: "/state/{id}/",
  ADD_SYSTEMS: "/state/add/system",
  REMOVE_SYSTEMS: "/state/remove/system",
};

export function find(params?: object) {
  return Gondor.API.get(ACTIONS.STATE, { params });
}

export function findOne(id: number | string) {
  id = id.toString();
  return Gondor.API.get(ACTIONS.STATE_ITEM.replace("{id}", id));
}

export function create(body: object) {
  return Gondor.API.post(ACTIONS.STATE, body);
}

export function update(id: number | string, body: object) {
  id = id.toString();
  return Gondor.API.patch(ACTIONS.STATE_ITEM.replace("{id}", id), body);
}

export function destroy(id: number | string) {
  id = id.toString();
  return Gondor.API.delete(ACTIONS.STATE_ITEM.replace("{id}", id));
}

export function addSystems(body: object) {
  return Gondor.API.post(ACTIONS.ADD_SYSTEMS, body);
}

export function removeSystems(body: object) {
  return Gondor.API.post(ACTIONS.REMOVE_SYSTEMS, body);
}
